module.exports = __webpack_public_path__ + "static/media/list.d67f215d.svg";